module.exports = __webpack_public_path__ + "static/media/facet_1_hyperboloid.841169d6.png";